import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import OrderPanelInfo from './order-panel-info'
import OrderItems from './order-items'
import OrderActions from './order-actions'

const OrderPanel = ({
  cancelUntil,
  className,
  createdAt,
  orderItems,
  canCancel,
  reference,
  returnWebUrl,
  statusWebUrl,
  total,
  trackingInfos,
  uuid,
}) => {
  return (
    <div className={className} id={reference}>
      <Row className="visible-xs visible-sm hidden bls brs bts bbn mhn grid-border-between grid-border-between-sm">
        <Col md={12}>
          <OrderPanelInfo
            className="mbm mll"
            createdAt={createdAt}
            reference={reference}
            total={total}
          />
        </Col>
      </Row>
      <Row className="bas mhn grid-border-between grid-border-between-sm">
        <Col md={8} className="pll prl">
          <OrderItems orderItems={orderItems} limit={6} />
        </Col>
        <Col md={4} className="ptm pbl prl pll">
          <OrderPanelInfo
            className="hidden-xs hidden-sm"
            createdAt={createdAt}
            reference={reference}
            total={total}
          />
          <hr className="visible-xs visible-sm hidden" />
          <OrderActions
            cancelUntil={cancelUntil}
            canCancel={canCancel}
            returnWebUrl={returnWebUrl}
            statusWebUrl={statusWebUrl}
            trackingInfos={trackingInfos}
            uuid={uuid}
          />
        </Col>
      </Row>
    </div>
  )
}

OrderPanel.defaultProps = {
  className: '',
  statusWebUrl: null,
  returnWebUrl: null,
  trackingInfos: [],
}

OrderPanel.propTypes = {
  cancelUntil: PropTypes.string.isRequired,
  className: PropTypes.string,
  createdAt: PropTypes.string.isRequired,
  canCancel: PropTypes.bool.isRequired,
  orderItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  reference: PropTypes.string.isRequired,
  returnWebUrl: PropTypes.string,
  statusWebUrl: PropTypes.string,
  total: PropTypes.number.isRequired,
  trackingInfos: PropTypes.arrayOf(PropTypes.object),
  uuid: PropTypes.string.isRequired,
}

export default OrderPanel
